















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { DxButton, DxSelectBox, DxRadioGroup } from 'devextreme-vue';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import CustomStore from 'devextreme/data/custom_store';
import CommonModule, { QuestelServicesClient } from '@questelservices/common';
import { Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import store from '../../store';
import { OrderCase } from '../../models/OrderCase';
import { UserSetting, UserSettingReportName, UserSettingName, OrderingMethod } from '@/models/UserSetting';
import { UserSettingFilter } from '../../models/UserSettingFilter';
import _ from "lodash";
import { UserService } from '@/service/UserService';
import { Popup } from '@questelservices/common-vue';
import { DxCheckBox } from 'devextreme-vue/check-box';

const draggable = require('vuedraggable');
const commonState = getModule(CommonModule, store);
const CASE_ORDER_SELECTION = [
    "Phase",
    "Country",
    "Agent",
    "Filing Type"
]

const FONT_SIZES_AVAILABLE = [
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]

@Component({
    components: {
        draggable,
        DxButton,
        DxSelectBox,
        DxToolbar,
        DxItem,
        Popup,
        DxCheckBox,
        DxRadioGroup
    }
})
export default class PhaseAssignmentOrderSetupDialog extends Vue {
    @Prop({ default: false })
    showDialog!: boolean;

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value) {            
        this.$emit("hiding");
    }       

    @Watch("showDialog")
    async onPropertyChanged(value: boolean, oldValue: boolean) {
       if(value){
            this.errorResponseMessage = undefined
            this.isDragging = true;
            let dbValCaseOrder = await this.getDataSource();
            this.sortableArray = dbValCaseOrder;
            this.selectedFontSize = await this.getUserPreferenceFontSize() || 12;
            this.autoSkipValue = await this.getAutoskipPreference();
            this.selectedOrderingOption = await this.getOrderingMethodPreference();
            this.isDragging = false;
       }
    }

    get dragOptions() {
        return {
            animation: 200,
            group: "description",
            disabled: false,
            ghostClass: "ghost"
        }
    }

    private orderingOptions: string[] = [
        OrderingMethod.ByMatterName,
        OrderingMethod.ByServiceCost,
        OrderingMethod.ByTotalCost 
    ];

    private selectedOrderingOption: string = OrderingMethod.ByMatterName;
 
    isDragging: boolean = true;
    sortableArray: OrderCase[] = [];
    userService: UserService;
    option: UserSettingFilter = {
        reportName: UserSettingReportName.ManualCoding,
        name : UserSettingName.CaseDisplayOrder
    }
    optionUserPref: UserSettingFilter = {
        reportName: UserSettingReportName.UserPreference,
        name : UserSettingName.DataTableFontSize
    }
    autoSkipPref: UserSettingFilter = {
        reportName: UserSettingReportName.UserPreference,
        name : UserSettingName.AutoSkip
    }
    private orderingPref: UserSettingFilter = {
        reportName: UserSettingReportName.ManualCoding,
        name: UserSettingName.OrderingMethod
    };
    errorResponseMessage:string | undefined = "undefined";
    accountId: number | undefined;
    fontSizesAvailable: number[] = FONT_SIZES_AVAILABLE;
    selectedFontSize: number = 12;
    autoSkipValue: boolean = false;

    constructor() {
        super();
        this.userService = new UserService();            
    }

    getDataSource(): Promise<any> | undefined {            
        return this.userService.getUserSettingsWithFilter(this.option)
                .then((result : UserSetting[])  => {
                    if (!result) {
                        throw result;
                    }

                    if(result.length > 0) {
                        let dbVal = _.orderBy(result, u => u.SortOrder, ['asc']);

                        let mappedDbVal = dbVal.map((item : UserSetting)=> {
                            let res : string = item.Value;

                            return res;
                        });

                        return _.union(mappedDbVal, CASE_ORDER_SELECTION).map((item: string)=> {
                                    let res: OrderCase = {
                                        name : item,
                                        fixed : dbVal.length > 0 ? (_.find(dbVal, i =>  i.Value === item) ? false : true) : true
                                    }

                                    return res;
                                });
                    }

                    return CASE_ORDER_SELECTION.map((item: string)=> {
                                    let res: OrderCase = {
                                        name : item,
                                        fixed : true
                                    }

                                    return res;
                                });
                })
                .catch(result => {
                    if (result && result.Message) {
                        throw result.Message;
                    } else {
                        throw "Error loading data.";
                    }

                    return undefined;
                });            
    } 

    private getAutoskipPreference(): Promise<any> | undefined {            
        return this.userService.getUserSettingsWithFilter(this.autoSkipPref)
            .then((result: UserSetting[]) => {
                let autoSkip = _.find(result, (item:UserSetting) => {
                                    return item.ReportName === UserSettingReportName.UserPreference &&
                                            item.Name === UserSettingName.AutoSkip;
                                }) || false;

                return (autoSkip ? autoSkip.Value == 'true': false);
            })
            .catch((err: any) => false);
    }

    private getUserPreferenceFontSize() : Promise<any> | undefined {            
        return this.userService.getUserSettingsWithFilter(this.optionUserPref)
            .then((result : UserSetting[])  => {
                var fontSize = _.find(result, (item:UserSetting) => {
                                return item.ReportName === UserSettingReportName.UserPreference &&
                                        item.Name === UserSettingName.DataTableFontSize;
                            });

                return fontSize ? +fontSize.Value : fontSize;
            })
            .catch(result => {
                    if (result && result.Message) {
                        throw result.Message;
                    } else {
                        throw "Error loading data.";
                    }

                    return undefined;
            });
    }

    private getOrderingMethodPreference(): Promise<any> | undefined {            
        return this.userService.getUserSettingsWithFilter(this.orderingPref)
            .then((result: UserSetting[]) => {                    
                let orderingMethod = _.find(result, (item: UserSetting) => {
                                    return item.ReportName === UserSettingReportName.ManualCoding &&
                                            item.Name === UserSettingName.OrderingMethod;
                                });
                
                return orderingMethod ? orderingMethod.Value : OrderingMethod.ByMatterName;
            })
            .catch((err: any) => false);
    }

    displayOrder(element: OrderCase, index: number): string {
        let elem = element;
        let result: string = "";

        if(!elem.fixed) {
            result = (index + 1).toString();
        }

        return result;
    }

    unselectElement(element: OrderCase): void {
        this.errorResponseMessage = undefined;

        element.fixed = !element.fixed;

        this.sortableArray = _.sortBy(this.sortableArray, u => u.fixed);
    }

    async saveCaseOrder() {
        this.errorResponseMessage = undefined;
        let hasError: boolean = false;

        await Promise.all([this.saveUserPref(), this.saveAutoSkip(), this.saveManualCaseOrder() ])
        .then(success => {                
            let userSettings: UserSetting[] = [];
            success.forEach(element => {
                if(element.Success && element.Data && element.Data.length > 0) {
                    element.Data.forEach((elem : any)=> {
                        userSettings.push(elem);
                    })
                    
                }
            });

            this.$root.$emit("user-settings-changed", userSettings);
            this.showingDialog = false;
        })
        .catch(err => {
            this.errorResponseMessage = "Failed to save database.";
        });
    }

    hidingDialog() {
        this.showingDialog = false;
    }

    saveAutoSkip() : Promise<any> {
        let autoSkip : UserSetting[] = [
            {
                ReportName : UserSettingReportName.UserPreference,
                Name : UserSettingName.AutoSkip,
                Value : this.autoSkipValue.toString(),
                SortOrder : undefined
            }
        ]

        return this.userService.insertUserSettings(autoSkip, this.autoSkipPref)
                .then(success => {

                    this.$emit('on-auto-skip-changed', this.autoSkipValue);
                    return success;
                })
                .catch( error => {
                    return [];
                });
    }

    saveUserPref() : Promise<any> {
        let userPref : UserSetting[] = [ 
            {
                ReportName : UserSettingReportName.UserPreference,
                Name : UserSettingName.DataTableFontSize,
                Value : this.selectedFontSize.toString(),
                SortOrder : undefined
            }
        ];
        return this.userService.insertUserSettings(userPref, this.optionUserPref)
                .then(success => {
                    this.$root.$emit("user-preference", this.selectedFontSize);
                    return success;
                })
                .catch( error => {
                    return [];
                });
    }

    private async saveManualCaseOrder() : Promise<any> {
        let toSave = _.filter(this.sortableArray, i => !i.fixed).map((item: OrderCase) => {
            if(!item.fixed) {
                let model : UserSetting = {

                    ReportName : UserSettingReportName.ManualCoding,
                    Name : UserSettingName.CaseDisplayOrder,
                    Value : item.name,
                    SortOrder : this.sortableArray.indexOf(item) + 1
                }

                return model;
            }
        });

        let resultCaseOrder = await this.userService.insertUserSettings((toSave as UserSetting[]), this.option);

        let orderingMethod : UserSetting =
            {
                ReportName : UserSettingReportName.ManualCoding,
                Name : UserSettingName.OrderingMethod,
                Value : this.selectedOrderingOption,
                SortOrder : undefined
            };            
        
        let resultOrdeMethod = await this.userService.insertUserSettings([ orderingMethod ], this.orderingPref);

        toSave.push(orderingMethod);

        this.$emit('case-display-order-saved', toSave);

        return resultCaseOrder.Success &&  resultOrdeMethod.Success;                    
    }        
}
